import { render, staticRenderFns } from "./SupplyFormatDownload.vue?vue&type=template&id=4d27dd98"
import script from "./SupplyFormatDownload.vue?vue&type=script&lang=js"
export * from "./SupplyFormatDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports